<template>
    <el-row>
      <el-col :span="24">
        <div class>
          <div class="head">
          </div>
          <div class="center">
            <div class="choose">
              <div class="top">
                <div class="line_box">
                  <span class="line_box_left">技术领域：</span>
                  <div :class="['line_box_right', openLineTech ? 'line_wrap' : '']">
                    <div
                      class="qunp"
                      :class="[TechA == null ? 'isActiv' : '']"
                      @click="changeTech(null)"
                    >全部</div>
                    <div class="itemind">
                      <span
                       
                        :class="[TechA == item.ID ? 'isActiv' : '']"
                        v-for="(item, index) in TechFieldEnumArr"
                        :key="index"
                        @click="changeTech(item.ID)"
                      >{{ item.Title }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
  
            <!--  -->
            <el-row>
              <el-col :span="18" id="elcol">
                <div class="sort_count" ref="basicInformation">
                  <div class="left">
                    <span :class="sortin == null ? 'iscong' : ''" @click="recomSort(null)">综合排序</span>
                    <div class="left_sort">
                      <div @click="timeSort(1)">
                        <span :class="sortin == 1 ? 'iscong' : ''">发布时间</span>
                        <img v-if="setstrot" src="../../../assets/library/路径 3128.png" alt />
                        <img v-else class="stingimg" src="../../../assets/library/路径 3128.png" alt />
                      </div>
                     
                    </div>
                  </div>
                </div>
                <div class="cenong-left-conent" >
                  <ul class="clc-ui" v-if="itemList.length >= 1" >
                    <li v-for="item in itemList" :key="item.ID" >
                      <div @click="talent(item.id)">
                        <div class="clc-lia">
                          <div class="clcig" >
                            <video controls :src="url"></video>
                           
                          </div>
                      
                        </div>
                        <div>
                          <div class="Adminis" >{{ item.name}}</div>
                          <div class="xinging">
                            <span>发布时间：{{ item.createDate }}</span>
                          </div>
                          <div class="xinging">
                            <span>播放量 ：{{ item.PlaybackVolume }}</span>
                          </div>
                        </div>
                      </div>
                  
                    </li>
                  </ul>
                  <div v-else>
                    <empty />
                  </div>
                </div>
              </el-col>
              <el-col :span="6" id="elco">
                <div class="cenong-right-top">
                  <div class="crtone">
                    <div class="crtone-d">
                      <img src="../../../assets/library/蒙版组 124.png" alt />
                      <h3>相关技术需求推荐</h3>
                    </div>
                   
                  </div>
                  <div
                    class="crttwo"
                    v-for="item in talrowetList"
                    :key="item.ID"
                    @click="crttid(item)"
                  >
                    <div class="crttwoimg">
                      <img :src="item.PictureUrl" alt />
                    </div>
                    <div class="crttwotext">
                      <b class="one">{{ item.Title }}</b>
                      <div class="cet-cil">
                        技术领域：
                        <span class="cet-span">{{ item.ModeOfCooperation }}</span>
                      </div>
                      <div class="cet-ciltwo">
                        项目阶段：
                        <span class="cet-span">
                          {{
                          item.ProjectPhase
                          }}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="cenong-right-top">
                  <div class="crtone">
                    <div class="crtone-d">
                      <img src="../../../assets/library/蒙版组 124.png" alt />
                      <h3>科研平台推荐</h3>
                    </div>
                
                  </div>
                  <div
                    class="crttwo1"
                    v-for="item in talrowetList"
                    :key="item.ID"
                    @click="crttid(item)"
                  >
                    <div class="crttwoimg">
                      <img :src="item.PictureUrl" alt />
                    </div>
                    <div class="crttwotext">
                      <b class="one">{{ item.Title }}</b>
                    </div>
                  </div>
                </div>
                <div class="cenong-right-top">
                  <div class="crtone">
                    <div class="crtone-d">
                      <img src="../../../assets/library/蒙版组 124(1).png" alt />
                      <h3>创新人才推荐</h3>
                    </div>
                   
                  </div>
                  <div
                    class="crttwo"
                    v-for="item in talcltList"
                    :key="item.ID"
                    @click="crtto(item.ID)"
                  >
                    <div class="crttwoimg">
                      <img :src="item.PictureUrl" alt />
                    </div>
                    <div class="crttwotext">
                      <b class="one">{{ item.Title }}</b>
                      <div class="crtt-two">
                        预算资金：
                        <span>{{ item.InvestMoney }}万元</span>
                      </div>
                      <div class="crttwo-ji">
                        技术领域：
                        <span>
                          {{
                          item.TechFieldEnum
                          }}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </el-col>
            </el-row>
            <!-- 分页 -->
            <Pagination
              :limit.sync="taleget.pageSize"
              :page.sync="taleget.page"
              :total="total"
              @pagination="talentList"
            />
          </div>
        </div>
      </el-col>
    </el-row>
  </template>
  
  <script>
  import { getAction, postAction } from '@/api/api'
  import empty from '@/components/empty.vue'
  import Pagination from '../components/Pagination/paginationpro.vue'
  import qs from 'qs'
  import { fruitChoose, library, VideoLectureHallHandle } from '@/api/url'
  export default {
    name: 'Organization',
    data() {
      return {
        //人才库参数
        taleget: {
          action: 'GetPageListPC',
          page: 1,
          sort:'ah.createDate DESC',
          name: '',
          limit: 16,
          CollegesUniversitiesGUID:this.$route.query.id
        },
        centerDialogVisible: false, //弹框
        total: 0,
        //人才库列表
        itemList: [],
        total: 1,
        sortA: false, //综合排序
        talrowetList: [], //热门成果
        talcltList: [], //热门需求
        searchForm: {
          action: 'Get_AchievementList',
          pageSize: 10, //一页多少条
          page: 1, //	第几页
          strSort: '', // 	//发布时间 上 a.UpdateTime ASC //发布时间 下 a.UpdateTime DESC //热度 上 b.ClickRank ASC //热度 下 b.ClickRank DESC //金额 上 a.InvestInFunds ASC //金额 下 a.InvestInFunds DESC
          strTechFieldEnum: '', //	技术领域id
          strPropertystatus: '', //	知识产权状况id
          strProjectPhase: '', //	项目阶段id
          strCooperaType: '', //	合作方式id
          strBudgetary: '', //	投入资金id
          strtitle: '', // 	搜索关键字
          strCountries: '', //	0：国内 1：国外
          strCitys: '', //	国内-省市ID
          strCountryText: '', //	国外-国家ID
        },
        TechFieldEnumArr: [],
        TechA: null, // 技术激活
        openLineTech: false, // 技术展开
        KonwA: '', // 技术激活
        tjiu: null, //技术库
        child: null, //国家
        sortin: null, //排序
        istrue: false, //时间排序
        isroung: false, //热度排序
      }
    },
    props: {},
    components: {
      Pagination,
      empty,
    },
    created() {
      this.$bus.$emit('ChangeFocus', 3)
      window.localStorage.setItem('NowIndex', 3)
      if (this.$route.query.type) {
        this.TechA = this.$route.query.type
        this.taleget.strTechField = this.$route.query.type
      }
      console.log('+++++++',this.taleget.pageSize)
      //列表
      this.talentList()
      //热门成果
      this.talrowet()
      //热门需求
      this.talclt()
      //lost
    },
    mounted() {
      this.$bus.$on('LoginSuccess', (e) => {
        if (e) {
          this.talentList()
        }
      })
      this.getChoose()
    },
    methods: {
      getChoose() {
        this.getTechFieldEnum()
      },
      getTechFieldEnum() {
        let data = {
          action: 'Achievements_getfields',
          ParentName: 'TechFieldEnum',
        }
        getAction(fruitChoose, data).then((res) => {
          res.map((item) => {
            this.TechFieldEnumArr.push(item)
          })
        })
      },
      //搜索清除
      clearVal() {
        this.talentList()
      },
      recomSort(n) {
        this.sortin = n
        this.taleget.strSort = ''
        this.isroung = false
        this.istrue = false
        this.talentList()
      }, // 综合排序
      timeSort(n) {
        this.sortin = n
        this.istrue = !this.istrue
        if (this.istrue) {
          this.taleget.strSort = 'a.UpdateDate DESC'
        } else {
          this.taleget.strSort = 'a.UpdateDate ASC'
        }
        this.isroung = false
        this.talentList()
      }, //时间排序
      hotSort(n) {
        this.sortin = n
        this.isroung = !this.isroung
        if (this.isroung) {
          this.taleget.strSort = ' a.ClickRank DESC'
        } else {
          this.taleget.strSort = ' a.ClickRank ASC'
        }
        this.istrue = false
        this.talentList()
      }, // 热度排序
      // 切换计划标签
      changeTech(item) {
        this.TechA = item
        this.taleget.strTechField = item
        this.taleget.page =1
        this.talentList()
      },
      // 技术更多
      openMoreTech() {
        this.openLineTech = !this.openLineTech
      },
      //数据列表
      talentList() {
        getAction(VideoLectureHallHandle, this.taleget).then((res) => {
          this.itemList = res.data
          this.total = res.count
        })
      },
      //专家库
      tquan(n) {
        this.tjiu = n
        this.taleget.page =1
        if (n == null) {
          this.taleget.strCategory = ''
          this.talentList()
          return
        }
        this.taleget.strCategory = n
        this.talentList()
      },
      //国家
      chilerd(int) {
        this.child = int
        this.taleget.page =1
        if (int == null) {
          this.taleget.strprovince = ''
          this.talentList()
          return
        }
        this.taleget.strprovince = int
        this.talentList()
      },
      //搜索
      hadsoun() {
        this.talentList()
        this.$refs.basicInformation.scrollIntoView({
              behavior: "smooth",  // 平滑过渡
              block: "start"  	// 上边框与视窗顶部平齐。默认值
          });
      },
      //搜索回车事件
      keyup() {
        let evt = window.event.keyCode
        if (evt == 13) {
          this.talentList()
        }
      },
      //成果跳转详情
      talent(id) {
        //判断是否是PC设备，true是，false不是
        let userAgentInfo = navigator.userAgent
        let Agents = ['Android', 'iPhone', 'SymbianOS', 'Windows Phone', 'iPod']
        let flag = true
        for (let j = 0; j < Agents.length; j++) {
          if (userAgentInfo.indexOf(Agents[j]) > 0) {
            flag = false
            break
          }
        }
        if (window.screen.width >= 768) {
          flag = true
        }
        if (flag) {
          let routeData = this.$router.resolve({
            path: '/lectureRoomDetail',
            query: { id: id },
          })
          window.open(routeData.href, '_blank')
        } else {
          window.location.href=this.Urls+'/Mobile/index.html#/TalentPoolDetail?id=' + id
          // this.$router.push({
          //   path:
          //     'http://www.nttzzc.com/Mobile/index.html#/TalentPoolDetail?id=' +
          //     id,
          // })
        }
      },
      //需求跳转详情
      crtto(id) {
        //判断是否是PC设备，true是，false不是
        let userAgentInfo = navigator.userAgent
        let Agents = ['Android', 'iPhone', 'SymbianOS', 'Windows Phone', 'iPod']
        let flag = true
        for (let j = 0; j < Agents.length; j++) {
          if (userAgentInfo.indexOf(Agents[j]) > 0) {
            flag = false
            break
          }
        }
        if (window.screen.width >= 768) {
          flag = true
        }
        if (flag) {
          let routeData = this.$router.resolve({
            path: '/demandDetail',
            query: { id },
          })
          window.open(routeData.href, '_blank')
        } else {
           window.location.href=this.Urls+'/Mobile/index.html#/NeedPoolDetail?id=' + id
          // this.$router.push({
          //   path:
          //     'http://www.nttzzc.com/Mobile/index.html#/NeedPoolDetail?id=' + id,
          // })
        }
      },
      //热门成果
      talrowet() {
        let data = {
          action: 'Get_Achievements',
          row: 2,
        }
        postAction(library, qs.stringify(data)).then((res) => {
          this.talrowetList = res
        })
      },
      //热门需求
      talclt() {
        let data = {
          action: 'Get_HotDemand',
          row: 2,
        }
        postAction(library, qs.stringify(data)).then((res) => {
          this.talcltList = res
        })
      },
      //成果库跳转
      crttid(item) {
        // console.log(item)
        //判断是否是PC设备，true是，false不是
        let userAgentInfo = navigator.userAgent
        let Agents = ['Android', 'iPhone', 'SymbianOS', 'Windows Phone', 'iPod']
        let flag = true
        for (let j = 0; j < Agents.length; j++) {
          if (userAgentInfo.indexOf(Agents[j]) > 0) {
            flag = false
            break
          }
        }
        if (window.screen.width >= 768) {
          flag = true
        }
        if (flag) {
          let routeData = this.$router.resolve({
            path: '/fruitDetail',
            query: { id: item.ID },
          })
          window.open(routeData.href, '_blank')
        } else {
           window.location.href=this.Urls+'/Mobile/index.html#/AchievementDetail?id=' + item.ID
          // this.$router.push({
          //   path:
          //     'http://www.nttzzc.com/Mobile/index.html#/AchievementDetail?id=' +
          //     item.ID +
          //     '&Score=' +
          //     5,
          // })
        }
      },
      //关注
      concern(id) {
        let data = window.localStorage.getItem('RealName')
        if (data == '') {
          this.$confirm('当前未登录,是否跳转到登录页?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
          })
            .then(() => {
              this.$bus.$emit('dialogVisible', true)
            })
            .catch(() => {
              this.$message({
                type: 'info',
                message: '已取消',
              })
            })
        } else {
          let b = window.localStorage.getItem('RealID')
          let data = {
            action: 'Collection_Items',
            ProjectID: id,
            UserID: b,
            type: 3,
          }
          postAction(library, qs.stringify(data)).then((res) => {
            if (res.status == 'n') {
              this.$message.success('取消关注')
            } else {
              this.$message.success('已经关注')
            }
            this.talentList()
          })
        }
      },
      //登陆成功
      LoginSuccess() {
        let data = {
          action: 'Get_UserInfo',
        }
        postAction(library, qs.stringify(data)).then((res) => {
          this.RealName = res.RealName
          window.localStorage.setItem('RealName', res.RealName)
        })
        this.$router.go(0)
      },
    },
    computed: {
      setstrot() {
        return this.istrue
      },
      setaleget() {
        return this.taleget
      },
    },
  }
  </script>
  
  <style lang="scss" scoped>
  .head {
    width: 100%;
    height:9rem;
    // background-image: url('../../../assets/library/chengguo/组 3826.png');
    background-size: 100% 21.875rem;
  }
  .form {
    width: 45rem;
    height: 4rem;
    margin: 0 auto;
    padding-top: 5.75rem;
    .el-input {
      width: 37.25rem;
      /deep/.el-input__inner {
        height: 4rem !important;
        padding-left: 3.5rem;
        font-size: 1rem;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #999999;
        opacity: 1;
      }
      /deep/ .el-input__prefix {
        left: 1.25rem;
        .el-input__icon {
          font-size: 1.25rem;
          height: 4.5rem;
        }
      }
      /deep/ .el-input-group__append {
        border: none;
      }
      .el-button--color {
        background: #2769dc;
        border: none;
  
        height: 4rem;
        border-radius: 0;
        ::v-deep span {
          font-size: 1.25rem;
          font-family: Microsoft YaHei;
          font-weight: bold;
          line-height: 0rem;
          color: #ffffff;
          opacity: 1;
        }
      }
    }
  }
  ::v-deep .el-form-item {
    margin-right: 0 !important;
  }
  /deep/ .btn-prev,
  .btn-next {
    background-color: #fff !important;
  }
  .center {
    transform: translateY(-5.75rem);
    width: 87.5rem;
    margin: 0 auto;
  }
  
  .choose {
    display: flex;
    flex-direction: column;
    // justify-content: space-around;
    // height: 40.375rem;
    background: #ffffff;
    box-shadow: 0rem 0.1875rem 1rem rgba(0, 0, 0, 0.08);
    opacity: 1;
    // padding: 2.0625rem 1.625rem;
    .top {
      .line_box {
        margin-bottom: 1.5rem;
        display: flex;
        align-items: baseline;
        .line_box_left {
          min-width: 6.25rem;
          text-align: left;
          font-size: 1rem;
          font-family: Microsoft YaHei;
          font-weight: bold;
          color: #4a4a4a;
          padding: 0.5rem 0.96rem;
        }
        .line_box_right {
          display: flex;
          overflow: hidden;
          flex: 1;
          span {
            white-space: nowrap;
            font-size: 1rem;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #666666;
            opacity: 1;
            padding: 0.375rem 1.125rem;
            text-align: left;
            cursor: pointer;
          }
          .isActiv {
            cursor: pointer;
            background: #2769dc;
            opacity: 1;
            color: #ffffff;
            border-radius: 0.3125rem;
            line-height: auto;
            padding: 0.375rem 1.125rem;
          }
        }
        .line_wrap {
          flex-wrap: wrap;
        }
      }
    }
    .botm {
      p {
        font-size: 1rem;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #666666;
        opacity: 1;
        img {
          width: 0.4375rem;
          height: 0.75rem;
          transform: rotateZ(-90deg);
        }
      }
    }
  }
  .sort_count {
    display: flex;
    justify-content: space-between;
    height: 4.375rem;
    background: #ffffff;
    box-shadow: 0rem 0.1875rem 1rem rgba(0, 0, 0, 0.08);
    opacity: 1;
    margin-top: 1.25rem;
    align-items: center;
    padding-left: 1rem;
    .left {
      display: flex;
      .sortActiv {
        color: #999999;
      }
      span {
        font-size: 1rem;
        font-family: Microsoft YaHei;
        font-weight: bold;
        color: #999;
        opacity: 1;
        cursor: pointer;
      }
      .left_sort {
        display: flex;
        align-items: center;
        div {
          cursor: pointer;
          margin-left: 2.3125rem;
        }
        img {
          margin-left: 0.5625rem;
          width: 0.5625rem;
          height: 0.75rem;
        }
        .fanzhuan {
          transform: rotate(180deg);
        }
      }
    }
  }
  .cenong {
    width: 100%;
    height: auto;
    margin-top: 0.625rem;
    overflow: hidden;
  }
  .cenong-left {
    float: left;
  }
  .cenong-right {
    float: right;
    width: 14.375rem;
    height: auto;
    margin-top: 1.875rem;
    padding: 0 0.9375rem;
    box-sizing: border-box;
    box-shadow: 0rem 0.1875rem 1rem rgba(0, 0, 0, 0.08);
  }
  .cenong-right-top {
    box-shadow: 0rem 0.1875rem 1rem rgba(0, 0, 0, 0.08);
    margin-top: 1.25rem;
    overflow: hidden;
    width: 20.875rem;
    float: right;
  }
  .crtone {
    height: 5rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 1.5rem;
    position: relative;
  }
  .crtone-d {
    display: flex;
    font-size: 1.25rem;
    align-items: center;
  }
  .crtone-d h3 {
    margin-left: 0.3125rem;
  }
  .crtone-d img {
    height: 1.5625rem;
  }
  .crtone-g a {
    color: #999;
    font-size: 1.125rem;
    right: 1.5rem;
    bottom: 1.875rem;
    line-height: 0.125rem;
  }
  .crtt-two {
    color: rgba(208, 208, 208, 1);
  }
  .crtt-two span {
    color: #f15916;
    font-family: Microsoft YaHei;
  }
  .crttwo {
    height: 16.625rem;
    border: 0.0625rem solid #eee;
    margin: 0 1.5rem 1.25rem;
    cursor: pointer;
  }
  .crttwo1 {
    height: 12.625rem;
    border: 0.0625rem solid #eee;
    margin: 0 1.5rem 1.25rem;
    cursor: pointer;
  }
  .crttwoimg {
    width: 100%;
    height: 9.6875rem;
    background: #333333;
  }
  .crttwoimg img {
    width: 100%;
    height: 100%;
    float: left;
  }
  .crttwotext {
    text-align: left;
    padding: 0.7rem;
    line-height: 1.6875rem;
  }
  .crttwotext div {
    font-size: 1rem;
  }
  .crttwo-ji {
    color: rgba(208, 208, 208, 1);
    line-height: 2rem;
  }
  .crttwo-ji span {
    color: #8b8b8b;
  }
  .cet-cil {
    color: rgba(208, 208, 208, 1);
  }
  .cet-ciltwo {
    line-height: 2rem;
    color: rgba(208, 208, 208, 1);
  }
  .cet-span {
    color: rgba(139, 139, 139, 1);
  }
  .crttwotext .one {
    display: inline-block;
    width: 100%;
    font-size: 1.25rem;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    margin-bottom: 0.3125rem;
  }
  .cenong-left-conent {
    margin-top: 1.25rem;
    overflow: hidden;
    padding-top: 1.25rem;
  }
  .clc-ui {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    margin-left: 0.25rem;
    margin-right: 0.25rem;
  }
  .clc-ui:after {
    content: '';
    width: 20.6875rem;
  }
  .clc-ui li {
    padding: 1rem;
    width: 20.6875rem;
    height: 15rem;
    float: left;
    box-shadow: 0rem 0.1875rem 1rem rgba(0, 0, 0, 0.08);
    box-sizing: border-box;
    min-height: 21.375rem;
    margin-bottom: 1.8125rem;
    
    cursor: pointer;
    &:hover {
      box-sizing: border-box;
     
      .Adminis{
        color:#0561d2
      }
    }
  }
  .clc-lia {
    position: relative;
    height:13rem;
    width: 18.68rem;
    overflow: hidden;
    margin-bottom:1rem;
    video{
      height:14rem;
    width: 22.68rem;
            position: absolute;
  top: -1rem;
  left:-10rem;
  object-fit: contain; 
          }
  }
  .clcig {
    position: absolute;
    top: 0.5rem;
    right: 0.0625rem;
    z-index: 9;
    width: 9.6875rem;
    height: 9.6875rem;
    background: #fff;
    border-radius: 50%;
   
  }

  .clc-lia-name {
    width: 14rem;
    height: 6.875rem;
    background: #f7f7f7;
    margin-top: 3.125rem;
    text-align: left;
    padding: 1.875rem 1.25rem;
    box-sizing: border-box;
    position: relative;
  }
  .gang {
    width: 0.5rem;
    height: 3.25rem;
    position: absolute;
    top: 1.875rem;
    left: -0.17rem;
    background: #0561d2;
  }
  .clc-lia-name div b {
    display: block;
    font-size: 1.25rem;
    width: 7rem;
    height: 1.875rem;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
  }
  .Adminis {
    text-align: left;
    display: block;
   font-weight: bold;
   font-size:1.5rem;
    // height: 2rem;
  }
  #elcol {
    padding-right: 0.625rem !important;
  }
  #elco {
    max-width: 22.5rem !important;
  }
  .clncol {
    color: #999;
    margin-right: 42px;
  }
  .xiaoelse {
    text-align: center;
    display: block;
    margin: 0 auto;
  }
  .xiaoelse img {
    width: 20%;
  }
  .xiaoelse p {
    margin-top: 1.25rem;
    color: #cccccc;
    text-align: center;
  }
  .xinging {
    min-width: 1.25rem;
    text-align: left;
    margin-top: 5px;
  }
  .xinging span {
   
    display: inline-block;
    height: 0.9375rem;
    line-height: 0.75rem;
    margin-top: 0.5625rem;
    color: #999;
  }
  .guanzhi {
    width: 6.3125rem;
    height: 2.1875rem;
    line-height: 2.1875rem;
    color: #fff;
    text-align: center;
    background: #2769dc;
    margin: 1.875rem auto 0;
    font-size: 0.875rem;
    font-family: Microsoft YaHei;
  }
  .iscong {
    color: #333 !important;
  }
  .stingimg {
    display: inline-block;
    transform: rotateX(180deg);
  }
  .qunp {
    white-space: nowrap;
    font-size: 1rem;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #666666;
    opacity: 1;
    padding: 0.375rem 1.125rem;
    text-align: left;
    cursor: pointer;
    height: 1.5rem;
  }
  .itemind {
    display: flex;
    flex-wrap: wrap;
  }
  </style>